import React from "react";
import PropTypes from "prop-types";
import { Box, Card, IconButton, Stack, Typography } from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const DocumentoPDF = ({ titulo = "Documento PDF", pdf = null, fechaPublicacion = null }) => {
  const formattedDate = fechaPublicacion
    ? new Date(fechaPublicacion).toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : null;

  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 1, sm: 2 },
        width: "100%",
        minWidth: 0,
        px: { xs: 1.5, sm: 2.5 },
        py: 2,
        border: "1px solid #dce4ed",
        borderRadius: 2,
        boxShadow: "0 2px 12px rgba(60, 72, 88, 0.06)",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
          width: 48,
          height: 48,
          borderRadius: 1.5,
          color: "#f44336",
          backgroundColor: "#fff0f0",
          border: "1px solid #ffd9d9",
          fontSize: 12,
          fontWeight: 800,
        }}
      >
        PDF
      </Box>

      <Box sx={{ minWidth: 0, flex: "1 1 auto", overflow: "hidden" }}>
        <Typography
          sx={{
            fontWeight: 700,
            color: "#0b1f33",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          title={titulo}
        >
          {titulo}
        </Typography>
        {formattedDate && (
          <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mt: 0.75 }}>
            <CalendarTodayOutlinedIcon sx={{ fontSize: 18, color: "#54708d" }} />
            <Typography variant="body2" color="text.secondary">
              {formattedDate}
            </Typography>
          </Stack>
        )}
      </Box>

      {pdf && (
        <>
          <IconButton
            component="a"
            href={pdf}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Ver ${titulo}`}
            sx={{ color: "#7895b5", flexShrink: 0 }}
          >
            <VisibilityOutlinedIcon />
          </IconButton>
          <IconButton
            component="a"
            href={pdf}
            target="_blank"
            rel="noopener noreferrer"
            download
            aria-label={`Descargar ${titulo}`}
            sx={{
              color: "#08233d",
              backgroundColor: "#f1f5f9",
              borderRadius: 1.5,
              flexShrink: 0,
            }}
          >
            <DownloadOutlinedIcon />
          </IconButton>
        </>
      )}
    </Card>
  );
};

DocumentoPDF.propTypes = {
  titulo: PropTypes.string,
  pdf: PropTypes.string,
  fechaPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};

export default DocumentoPDF;
